export default __webpack_public_path__ + "static/media/gg-logo.4c5ef4cc.svg";